<template>
  <div>
    <el-input
      v-model="localValue"
      :class="`required-value-${id}`"
      type="text"
      class="shadow-sm required-areas"
    />
    <p v-show="showError" class="mt-2 text-muted text-danger">
      {{ messageError }}
    </p>
  </div>
</template>
<script>
import mixinVModel from 'src/util/mixinVModel';
import i18n from 'src/i18n';

export default {
  name: 'TextCapture',
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 1000,
    },
  },
  mixins: [mixinVModel],
  methods: {
    validate() {
      if (
        (this.required === 1 && !this.localValue) ||
        (this.localValue &&
          (this.localValue.length < this.min ||
            this.localValue.length > this.max))
      ) {
        if (this.localValue && this.localValue.length < this.min) {
          this.messageError = `${i18n.t('common_words.text_length_less')} ${
            this.min
          }`;
        } else if (this.localValue && this.localValue.length > this.max) {
          this.messageError = `${i18n.t('common_words.text_length_greater')} ${
            this.max
          }`;
        }

        this.highlightItem(`required-value-${this.id}`);
        this.showMessageErrorLabel();

        return false;
      }

      return true;
    },
  },
};
</script>
